import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Icon, IconSize } from 'app/design-system/components/Icon';
import { useTranslation } from 'app/lang';
import { logoutAllTabs } from 'app/lib/auth/authChannel';
import { clearPreferencesStorage } from 'app/modules/LiveStream/local-storage-helpers';

import DropdownMenu from '../DropdownMenu';

import dictionary from './LogoutButtonItem.dictionary.json';

import styles from './LogoutButtonItem.module.scss';

type Props = {
  onClick: () => void;
};

const LogoutButtonItem: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleLogOutClick = useCallback(() => {
    onClick();
    clearPreferencesStorage();
    dispatch(logoutAllTabs());
  }, []);

  return (
    <DropdownMenu.Item data-test="headerMenu-logout"
                       divider="top">
      <button className={styles.logoutBtn}
              type="button"
              data-ga-event="logout"
              onClick={handleLogOutClick}>
        <Icon icon="logout"
              size={IconSize.MEDIUM}
              className={styles.logoutIcon} />
        {t(dictionary.logoutButton)}
      </button>
    </DropdownMenu.Item>
  );
};

export default LogoutButtonItem;
